import React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Divider,
  useTheme
} from "@mui/material";
import MKTypography from "../components/MKTypography";
import { PRIMARY_PINK } from "../constants";

function PrivacyPolicyPage() {
  const theme = useTheme();

  return (
    <Box sx={{ minHeight: "100vh", py: 4 }}>
      <Container maxWidth="md">
        <Paper sx={{ p: { xs: 3, md: 6 }, borderRadius: 2 }}>
          <MKTypography
            component="h1"
            variant="h3"
            fontWeight="bold"
            mb={3}
            sx={{ color: PRIMARY_PINK, textAlign: 'center' }}
          >
            Privacy Policy
          </MKTypography>
          
          <MKTypography variant="body2" color="text.secondary" mb={4} sx={{ textAlign: 'center' }}>
            Last updated: {new Date().toLocaleDateString()}
          </MKTypography>

          <Divider sx={{ mb: 4 }} />

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Information We Collect
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              San Diego Gaming collects the following types of information:
            </MKTypography>
            <Box component="ul" sx={{ pl: 3 }}>
              <MKTypography component="li" variant="body1" mb={1}>
                <strong>Email Addresses:</strong> We collect email addresses when you sign up for our newsletter or create an account to receive updates about gaming events and community activities.
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                <strong>Account Information:</strong> When you create an account, we collect your name, email address, and any profile information you choose to provide.
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                <strong>Usage Data:</strong> We may collect information about how you interact with our website, including pages visited and features used.
              </MKTypography>
            </Box>
          </Box>

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              How We Use Your Information
            </MKTypography>
            <Box component="ul" sx={{ pl: 3 }}>
              <MKTypography component="li" variant="body1" mb={1}>
                To send you newsletters and updates about gaming events in San Diego
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                To provide you with access to our gaming community platform
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                To improve our website and services
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                To communicate with you about your account or our services
              </MKTypography>
            </Box>
          </Box>

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Information Sharing
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              We do not sell, trade, or otherwise transfer your personal information to third parties. We may share your information only in the following circumstances:
            </MKTypography>
            <Box component="ul" sx={{ pl: 3 }}>
              <MKTypography component="li" variant="body1" mb={1}>
                With your explicit consent
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                To comply with legal obligations
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                To protect our rights and the safety of our users
              </MKTypography>
            </Box>
          </Box>

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Your Rights
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              As a California resident, you have the following rights regarding your personal information:
            </MKTypography>
            <Box component="ul" sx={{ pl: 3 }}>
              <MKTypography component="li" variant="body1" mb={1}>
                <strong>Right to Know:</strong> You can request information about what personal data we collect and how we use it
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                <strong>Right to Delete:</strong> You can request that we delete your personal information
              </MKTypography>
              <MKTypography component="li" variant="body1" mb={1}>
                <strong>Right to Opt-Out:</strong> You can unsubscribe from our emails at any time using the unsubscribe link in our emails
              </MKTypography>
            </Box>
          </Box>

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Data Security
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.
            </MKTypography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Cookies and Tracking
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              Our website may use cookies and similar tracking technologies to enhance your experience. You can control cookie settings through your browser preferences.
            </MKTypography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Contact Us
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              If you have any questions about this Privacy Policy or wish to exercise your rights, please contact us at:
            </MKTypography>
                        <Box sx={{ pl: 2 }}>
              <MKTypography variant="body1" mb={1}>
                <strong>Email:</strong> privacy@sandiegogaming.com
              </MKTypography>
            </Box>
          </Box>

          <Box sx={{ mb: 4 }}>
            <MKTypography
              component="h2"
              variant="h5"
              fontWeight="bold"
              mb={2}
              sx={{ color: PRIMARY_PINK }}
            >
              Changes to This Policy
            </MKTypography>
            <MKTypography variant="body1" mb={2}>
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
            </MKTypography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}

export default PrivacyPolicyPage;
